import { floorScene } from './floor';
import { kitchenScene } from './kitchen';
import { staircaseScene } from './staircase';
import { wallScene } from './wall';
import type { SceneDefinition, SceneId } from './types';

export { SCENE_IDS } from './types';
export type {
  ArtProps,
  SceneDefinition,
  SceneId,
  ScenePhotoSlot,
  SceneRegion,
  SurfaceKind,
} from './types';

/** The four scenes, in picker order. */
export const SCENES: readonly SceneDefinition[] = [
  kitchenScene,
  floorScene,
  wallScene,
  staircaseScene,
];

export function getScene(id: SceneId): SceneDefinition {
  return SCENES.find((scene) => scene.id === id) ?? kitchenScene;
}
